<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import type { SimpleImageBlock } from './simpleImageBlock.svelte';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			headline: string;
			cta_button: Array<any>;
			asset: Array<SimpleImageBlock>;
		}>['content'];
	}

	let { content }: Props = $props();

	let asset = $derived(content.asset[0]);
	let image = $derived(asset.asset);
	let desktopImage = $derived(asset.asset_desktop ?? asset.asset);
</script>

<section
	use:editable={content}
	class="bg-stone-4"
	style="--bg-image-mobile: url({image.filename}); --bg-image-desktop: url({desktopImage.filename})"
>
	<PageGrid16>
		<div
			class="cta-banner-content col-span-full flex h-[490px] w-full flex-col items-center justify-center max-lg:px-5 lg:mx-auto lg:aspect-video lg:h-full lg:max-h-[640px]"
		>
			<h1
				class="mb-9 text-balance text-center font-rhymes text-[43px]/[110%] font-light tracking-[-1.29px] text-stone-5 lg:w-1/2 lg:text-[52px]/[110%] lg:tracking-[-1.56px]"
			>
				{content.headline}
			</h1>

			<div>
				{#each content.cta_button as btn}
					<Blok content={btn} />
				{/each}
			</div>
		</div>
	</PageGrid16>
</section>

<style>
	section .cta-banner-content {
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		background-image: var(--bg-image-mobile);

		@media screen and (min-width: 1024px) {
			background-size: contain;
			background-image: var(--bg-image-desktop);
		}
	}
</style>
